import { render, staticRenderFns } from "./Cores.vue?vue&type=template&id=0fe9b5eb&scoped=true"
import script from "./Cores.vue?vue&type=script&lang=js"
export * from "./Cores.vue?vue&type=script&lang=js"
import style0 from "./Cores.vue?vue&type=style&index=0&id=0fe9b5eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe9b5eb",
  null
  
)

export default component.exports